import { Component, EnvironmentInjector, EventEmitter, Inject, Input, Output } from '@angular/core';
import { Router, RouterModule } from '@angular/router';
import { Modal, ModalOptions } from '@indice/ng-components';
import { TranslocoDirective, TranslocoPipe } from '@jsverse/transloco';
import { LanguageRouterLinkDirective } from '../../directives/language-router-link.directive';
import { localizeRoute } from '../../utilities/localizeRoutes';

export enum UnauthorizedRequestsTranslationSuffix {
  MAKE_OFFER = 'make-offer',
  REQUEST_CALLBACK = 'request-callback',
  REQUEST_WALKTHROUGH = 'request-walkthrough',
  REQUEST_SERVICES = 'request-services',
  DEFAULT = 'default'
}

@Component({
  selector: 'app-requests-unauthorized',
  standalone: true,
  imports: [RouterModule, TranslocoDirective, TranslocoPipe, LanguageRouterLinkDirective],
  templateUrl: './requests-unauthorized.component.html',
})
export class RequestsUnauthorizedComponent {
  @Input() suffix: UnauthorizedRequestsTranslationSuffix = UnauthorizedRequestsTranslationSuffix.DEFAULT;
  @Input() imgSrc = '../../../../assets/img/property-details.png'
  @Output() close = new EventEmitter();
  @Output() login = new EventEmitter();
  @Output() signUp = new EventEmitter();

  constructor(private _modal: Modal,@Inject(ModalOptions)
      private _options: ModalOptions<RequestsUnauthorizedComponent>,private router: Router,
      @Inject(EnvironmentInjector) private envInjector: EnvironmentInjector,) {
        this.suffix = this._options.initialState?.suffix as UnauthorizedRequestsTranslationSuffix;
        this.imgSrc = this._options.initialState?.imgSrc as string;
      }
      
  navigateToLoginWithRedirect(){
    localStorage.setItem('redirectRoute',  this.router.url)
    this.router.navigate([localizeRoute("/login", this.envInjector)])
  }
  onClose = () => {
    this.close.emit()
    this._modal.hide({ success: true });
  };

  onLogin = () => {
    this.login.emit();
    this._modal.hide({ success: true });
  }
  onSignUp = () => {
    this.signUp.emit();
    this._modal.hide({ success: true });
  }
}
